import { render, staticRenderFns } from "./wechatMp__list.vue?vue&type=template&id=3fcf51b0"
import script from "./wechatMp__list.vue?vue&type=script&lang=js"
export * from "./wechatMp__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports